import { IconWrapper } from '../runtime';
export default IconWrapper('three_d_model_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#6F7B84"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#5F6A72"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#8999A3"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 1.94141L12.5 4.19141V9.80944L8 12.0594L3.5 9.80944V4.19141L8 1.94141ZM5.78047 4.72822L8 3.61846L10.2185 4.7277L7.99906 6.11484L5.78047 4.72822ZM5 6.0093V8.88239L7.24906 10.0069V7.41497L5 6.0093ZM8.74906 10.0079L11 8.88239V6.00813L8.74906 7.41497V10.0079Z",
      "fill": "white"
    }
  })]);
});